import { render, staticRenderFns } from "./CardPlan.vue?vue&type=template&id=4832d53d&"
import script from "./CardPlan.vue?vue&type=script&lang=js&"
export * from "./CardPlan.vue?vue&type=script&lang=js&"
import style0 from "./CardPlan.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports